import React from "react";
import { Field } from "formik";
import MuiTextInput from "../../Common/MuiTextInput";
import { FormSection } from "./UIComponents";

export default ({ p, i, language, canEditForm }) => {
  return (
    <FormSection>
      <Field
        component={MuiTextInput}
        disabled={!canEditForm}
        fullWidth={true}
        label={language.Account_PhoneNumbers_Type[p.type]}
        name={`phoneNumbers[${i}].number`}
        placeholder={language.Account_PhoneNumber.Placeholder}
        type="text"
        autocomplete="tel"
      />
    </FormSection>
  );
};
